import React from "react";
import { Link } from "react-router-dom";

const FutureOilOverview = () => {
  return (
    <section className="futureoil-overview" style={{marginTop: '60px', marginBottom: '40px'}}>
      <div className="container">
        <div className="row gx-lg-5 align-items-center">
          {/* LEFT COLUMN (Text + Where/When + Button) */}
          <div className="col-lg-6">
            <div className="overview-left text-center text-lg-start">
              {/* Intro */}
              <div className="overview-title pb-4">
                <p className="mb-1 pink">OVERVIEW</p>
                <h2 className="mb-2">
                  DISCOVER <span className="pink">FutureOil 2026</span>
                </h2>
                <p>
                  FutureOil 2026 brings together industry leaders, innovators, and
                  researchers to explore the transformative role of{" "}
                  <strong>AI, data, and digital technologies</strong> in driving
                  the global shift toward a <strong>net-zero energy future</strong>.
                </p>
                <p className="mb-2">
                  This 100% virtual conference will showcase cutting-edge insights,
                  breakthrough solutions, and collaborative strategies that are
                  reshaping the future of energy.
                </p>
              </div>

              {/* Where & When */}
              <div className="row justify-content-start">
                <div className="col-md-6">
                  <div className="event-info-box align-items-center d-flex p-4 rounded bg-white box-shadow my-2">
                    <div className="event-info-icon text-center">
                      <i className="fa fa-map-marker text-white bg-pink rounded-circle me-3"></i>
                    </div>
                    <div className="location-info">
                      <h5 className="mb-1">WHERE</h5>
                      <small>100% Virtual Event</small>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="event-info-box align-items-center d-flex p-4 rounded bg-white box-shadow my-2">
                    <div className="event-info-icon text-center">
                      <i className="fa fa-calendar text-white bg-pink rounded-circle me-3"></i>
                    </div>
                    <div className="time-info">
                      <h5 className="mb-1">WHEN</h5>
                      <small>
                        Tuesday – Wednesday <br /> 21-22 April, 2026
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {/* Call-to-Action */}
              <div className="overview-btn mt-4">
                <Link to="/contact" className="btn">
                  View Latest Agenda<i className="fa fa-long-arrow-right ms-4"></i>
                </Link>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN (Benefit Cards + Images) */}
          <div className="col-lg-6">
            <div className="conference-left">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 px-2 pt-2">
                  <div className="event-benifit-list-left mb-4">
                    {/* Card 1 */}
                    <div className="benifit-list-box py-7 px-4 rounded mb-4 box-shadow bg-white">
                      <div className="list-box-icon">
                        <i className="fa fa-users pink mb-3" aria-hidden="true"></i>
                      </div>
                      <div className="list-box-body">
                        <h5 className="mb-2">Global Networking</h5>
                        <p className="mb-2 w-75 m-auto">
                          Connect with industry leaders, innovators, and researchers
                          from across the world.
                        </p>
                      </div>
                    </div>
                    {/* Card 2 */}
                    <div className="benifit-list-box py-7 px-4 rounded box-shadow bg-white">
                      <div className="list-box-icon">
                        <i className="fa fa-globe pink mb-3" aria-hidden="true"></i>
                      </div>
                      <div className="list-box-body">
                        <h5 className="mb-2">Energy Innovation</h5>
                        <p className="mb-2 w-75 m-auto">
                          Explore breakthrough solutions driving the shift toward a
                          net-zero energy future.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Right-side small card */}
                <div className="col-lg-6 col-md-6 px-2">
                  <div className="benifit-list-box py-7 px-4 rounded box-shadow bg-white">
                    <div className="list-box-icon">
                      <i className="fa fa-bar-chart pink mb-3" aria-hidden="true"></i>
                    </div>
                    <div className="list-box-body">
                      <h5 className="mb-2">AI & Data Insights</h5>
                      <p className="mb-2 w-75 m-auto">
                        Discover how AI, data, and digital technologies are
                        transforming the energy sector.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Optional Inline Styling */}
      <style>{`
        .overview-title h2 {
          font-size: 2rem;
          font-weight: bold;
        }
        .overview-title p {
          font-size: 1rem;
          line-height: 1.6;
        }
        .benifit-list-box {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .benifit-list-box:hover {
          transform: translateY(-5px);
          box-shadow: 0px 8px 20px rgba(0,0,0,0.1);
        }
      `}</style>
    </section>
  );
};

export default FutureOilOverview;
